import React from 'react';
import $ from 'jquery';

export default class BaseClass extends React.Component {
    constructor(props) {
        super(props);
    }

    goto(url) {
        this.props.history.push(url);
    }

    bindModel(event, model) {
        var node = $(event.target);
        if (!model) model = 'info';

        var info = this.state[model];
        info[node.attr('name')] = event.target.value;

        var obj = {};
        obj[model] = info;

        return new Promise((resolve, reject) => {
            this.setState(obj, () => {
                resolve();
            });
        });
    }

    changeInfo(key, value, model) {
        if (!model)
            model = 'info';

        let info = this.state[model];
        info[key] = value;

        var obj = {};
        obj[model] = info;

        return new Promise((resolve, reject) => {
            this.setState(obj, () => {
                resolve();
            });
        });
    }
}
